import React from 'react'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { GridPanelLayout, RenderIconFn, RenderHeaderFn } from '.'

type RenderContentFn = (props: {
  readonly layout: GridPanelLayout
  readonly iconSize: number
}) => React.ReactNode

interface GridDrilldownPanelViewProps {
  readonly layout: GridPanelLayout
  readonly renderIcon: RenderIconFn
  readonly renderHeader: RenderHeaderFn
  readonly renderContent: RenderContentFn
  readonly showHorizontalRule?: boolean
}

const defaultIconSize = 26
export const leftOffset = 35

export const GridDrilldownPanelView: React.FC<GridDrilldownPanelViewProps> = ({
  layout,
  renderIcon,
  renderHeader,
  renderContent,
  showHorizontalRule = true
}) => {
  const showWhiteBackgroundColor = layout === 'page'
  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        height: 77vh;
      `}
    >
      <div
        className={css`
          display: flex;
        `}
      >
        <div
          className={css`
            padding: 20px 0 0 ${leftOffset}px;
            ${showWhiteBackgroundColor === true &&
            `background-color: ${theme.color.white};`};
          `}
        >
          {renderIcon({
            defaultIconProps: {
              size: defaultIconSize,
              color: 'gray'
            }
          })}
        </div>
        <div
          className={css`
            display: flex;
            flex-direction: column;
            width: 100%;
          `}
        >
          <div
            className={css`
              padding: 20px 0 0 0;
              width: 100%;
              ${showWhiteBackgroundColor === true &&
              `background-color: ${theme.color.white};`};
            `}
          >
            {renderHeader({ layout })}
          </div>
        </div>
      </div>
      {showHorizontalRule && (
        <div
          className={css`
            border-top: 1px solid ${theme.color.neutral40};
            margin: 10px 30px;
          `}
        />
      )}
      <div
        className={css`
          flex: 1;
          margin-right: 25px;
        `}
      >
        {renderContent({ layout, iconSize: defaultIconSize })}
      </div>
    </div>
  )
}
